export const ADDON_PROVIDER_HUB = 'WowUpHub';
export const ADDON_PROVIDER_WOWINTERFACE = 'WowInterface';
export const ADDON_PROVIDER_TUKUI = 'TukUI';
